/**
 * app 管理
 */
import { stringify } from 'qs';
import request from '../utils/request';
import config from '../config';


// 查询 app 列表
export async function fetchAppList(params) {
  return request(`${config.domain11}/api/app/manager?${stringify(params)}`);
}

// 新增 app
export async function addNewApp(params = {}) {
  return request(`${config.domain11}/api/app/manager`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

// 删除 app
export async function deleteApp(appId) {
  return request(`${config.domain11}/api/app/manager?appId=${appId}`, {
    method: 'DELETE'
  });
}

// 编辑 app
export async function editApp({ appId, ...params }) {
  return request(`${config.domain11}/api/app/manager?appId=${appId}`, {
    method: 'PUT',
    body: {
      ...params
    }
  });
}

// app 详情
export async function fetchAppDetail(appId) {
  return request(`${config.domain11}/api/app/manager/detail?appId=${appId}`, {
    method: 'GET'
  });
}

// 获取 创建 app 时需要的appId和appSecret
export async function fetchAppId() {
  return request(`${config.domain11}/api/app/manager/getAppEnv`, {
    method: 'GET'
  });
}

// APP 导出触发
export async function startExport(appId) {
  return request(`${config.domain11}/api/app/manager/export?appId=${appId}`, {
    method: 'POST'
    // body: {}
  });
}

// APP 导出状态查询
export async function queryExportStatus(appId) {
  return request(`${config.domain11}/api/app/manager/export/status?appId=${appId}`, {
    method: 'GET'
  });
}

// APP 导入状态查询
export async function queryImportStatus(appId) {
  return request(`${config.domain11}/api/app/manager/import/status?appId=${appId}`, {
    method: 'GET'
  });
}

// APP 升级状态查询
export async function queryUpdateStatus(appId) {
  return request(`${config.domain11}/api/app/manager/upgrade/status?appId=${appId}`, {
    method: 'GET'
  });
}
// APP 状态查询
export async function queryStatus(appName) {
  return request(`${config.domain11}/api/metadata/app/${appName}/upgrade/status?type=app`, {
    method: 'GET'
  });
}

// app 运行状态切换
export async function containerActivity(params, isHiddenNote) {
  return request(`${config.domain11}/api/app/manager/containerActivity`, {
    method: 'PUT',
    body: {
      ...params
    }
  }, isHiddenNote);
}

// 批量启动app
export async function autoStart(params) {
  return request('/api/app/batch/autoStart', {
    method: 'PUT',
    body: params
  });
}

// 查询APP状态
export async function queryStartupStatus({ appId }) {
  return request(`${config.domain11}/api/app/manager/containerStatus?appId=${appId}`, '', true);
}
/**
 * APP管理api
 * fetchAppManagerList  查询
 * deleteAppManager  删除
 * queryInstallImportStatus 安装状态轮寻
 * startInstallExport  app设计器安装包导出
 * queryInstallExportStatus app设计器安装包导出状态轮询
 */
export async function fetchAppManagerList({ order, keyword, runStatus }) {
  let params = keyword ? `&keyword=${keyword}` : '';
  params += runStatus ? '&runStatus=UN_RUNNING' : '';
  return request(`${config.domain11}/openapi/installer/v1/apps?order=${order}${params}`, {
    method: 'GET'
  });
}

// app 运行状态切换
export async function changeStatus(params) {
  return request(`${config.domain11}/openapi/installer/v1/task`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

// app 配置信息更新 task
export async function getAppConfig({ taskId, appId }) {
  const params = taskId
    ? `taskId=${taskId}`
    : appId
      ? `appId=${appId}`
      : '';
  return request(`${config.domain11}/openapi/installer/v1/config?${params}`);
}


// task 配置信息更新
export async function putTaskIdConfig({ taskId, config: appConfig }) {
  return request(`${config.domain11}/openapi/installer/v1/config/${taskId}/bytask`, {
    method: 'PUT',
    body: {
      config: appConfig
    }
  });
}

// app 配置信息更新
export async function putAppIdConfig({ appId, config: appConfig }) {
  return request(`${config.domain11}/openapi/installer/v1/config/${appId}/byapp`, {
    method: 'PUT',
    body: {
      config: appConfig
    }
  });
}


// export async function deleteAppManager(appId) {
//   return request(`${config.domain11}/api/app/manager/install/${appId}`, {
//     method: 'DELETE'
//   });
// }
// // APP 安装包导入状态查询
// export async function queryInstallImportStatus(appId) {
//   return request(`${config.domain11}/api/app/manager/install/status?appId=${appId}&type=import`, {
//     method: 'GET'
//   });
// }
// // APP 安装包导出触发
// export async function startInstallExport(appId) {
//   return request(`${config.domain11}/api/app/manager/install/export?appId=${appId}`, {
//     method: 'POST'
//     // body: {}
//   });
// }
// // APP 安装包导出状态查询
// export async function queryInstallExportStatus(appId) {
//   return request(`${config.domain11}/api/app/manager/install/status?appId=${appId}&type=export`, {
//     method: 'GET'
//   });
// }

